import type { ShopifyCartItem } from "@redotech/shopify-client/ajax";
import { getRechargeProduct } from "@redotech/shopify-client/ajax";

export const isRedoItem = (item: ShopifyCartItem) =>
  item.vendor?.toLowerCase() === "re:do" ||
  item.title?.toLowerCase().includes("re:do");

export const isPackageProtection = (item: ShopifyCartItem) =>
  item.handle === "navidium-shipping-protection";

export const REDO_DISABLE_TAGS = ["redo-hidden"];

export const productMatchesTags = (productTags: string[], tags: string[]) => {
  return productTags.some((tag) => tags.includes(tag.toLowerCase()));
};

export const getSellingPlanId = async (
  redoItem: ShopifyCartItem,
  cart: any,
) => {
  const sellingPlans: any[] = [];
  // Check if any items in cart have a selling plan with recharge that are recurring
  for (const item of cart.items) {
    if (
      item.selling_plan_allocation?.selling_plan?.recurring_deliveries &&
      !isRedoItem(item)
    ) {
      const rechargeProductResponse = await getRechargeProduct(
        Shopify.shop,
        item.product_id.toString(),
      );
      let frequency: number = 0;
      let interval: string = "";
      for (const group of rechargeProductResponse.product.selling_plan_groups) {
        for (const plan of group.selling_plans) {
          if (
            plan.selling_plan_id ===
            item.selling_plan_allocation.selling_plan.id
          ) {
            frequency = plan.order_interval_frequency;
            interval = plan.order_interval_unit_type;
          }
        }
      }

      sellingPlans.push({
        id: item.selling_plan_allocation.selling_plan.id,
        order_interval_frequency: frequency, // number
        order_interval_unit_type: interval, // one of "day", "week", "month"
      });
    }
  }
  // If any have the selling plan, pick out the desired selling plan, if there is more than 1 (most frequent)
  let selectedSellingPlan = sellingPlans[0] || null;
  if (sellingPlans.length > 1) {
    for (const plan of sellingPlans) {
      const unitDays =
        plan.order_interval_unit_type === "month"
          ? 30
          : plan.order_interval_unit_type === "week"
          ? 7
          : 1;
      let newFrequencyInDays = plan.order_interval_frequency * unitDays;
      let currentFrequencyInDays =
        selectedSellingPlan.order_interval_frequency * unitDays;
      if (newFrequencyInDays < currentFrequencyInDays) {
        selectedSellingPlan = plan;
      }
    }
  }
  if (!!selectedSellingPlan && !!redoItem.product_id) {
    // After selecting the correct selling plan,
    // find the matching selling plan on the redo item in recharge (same interval and frequency)
    const redoProductInRecharge = await getRechargeProduct(
      Shopify.shop,
      redoItem.product_id.toString(),
    );
    let sellingPlanId: number | null = null;
    for (const group of redoProductInRecharge.product.selling_plan_groups) {
      if (sellingPlanId) {
        // Once we find the correct selling plan, break out of the loop
        break;
      }
      for (const plan of group.selling_plans) {
        if (
          plan.order_interval_frequency ===
            selectedSellingPlan.order_interval_frequency &&
          plan.order_interval_unit_type ===
            selectedSellingPlan.order_interval_unit_type
        ) {
          sellingPlanId = plan.selling_plan_id;
          // Once we find the correct selling plan, break out of the loop
          break;
        }
      }
    }
    // Add the selling plan to the redo product.
    return sellingPlanId;
  } else {
    // There are no selling plans, so we shouldn't add one to redo
    return null;
  }
};
